// extracted by mini-css-extract-plugin
module.exports = {"ErrorPage":"ErrorPage_ErrorPage__2mRaQ","Logo":"ErrorPage_Logo__3dOTK","Oops":"ErrorPage_Oops__3x-HA","ErrorText":"ErrorPage_ErrorText__32WzE","Box":"ErrorPage_Box__3ZClu"};